// extracted by mini-css-extract-plugin
export default {"container":"CoutdownTimer_container__caNzo"};